import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';
import { Documentscan } from 'src/app/classes/documentscan';

@Injectable({
  providedIn: 'root',
})
export class GlobalDataService {
  public language: any = 'en';
  public loading: any;
  public menu: any = [];
  directDepositUploadDocs: any = '';
  currentFaq: any = null;
  holidaysList: any = [];
  paymentInfo: any;
  selectedCatType: any;
  selectedDocType: any;
  selectedCategory: any;
  docHistoryDetails: any;
  isAddPage: any;
  isDirectDeposits: any;
  docScanConfig: any;
  docTypeConfig: any;
  appVersion: any;
  envClass = '';
  deviceInfo: any;
  showAppRatingAndroid: any;
  showAppRatingIos: any;
  currentAppVersion: any;
  savedDocuploadNavigation: any;
  technicalSupportBackUrl: string = 'tabs/more';
  savedDocuploadDLNavigation: any;
  savedDocuploadLSNavigation: any;
  selectedPaymentOption: any;
  selectedPaymentOptionRadio: any;
  selectedPaymentOptionDate: any;
  selectedPaymentOptionEmpDate: any;
  selectedPaymentRadioIndex: any;
  lastActivityTime: any;
  displayTimer: any;
  isLogout = false;
  alertTimer: any;
  userObject: any;
  platform: any = '';
  alertNotificationsCount: any = 0;
  userAgreementStatus: string = 'N';
  agreementPageVisitedCount: any = 0;
  homePageVisitedCount: any = 0;
  mrcMraPrevQuestionsNavigation: string = '';
  documentScan: any;
  // Shared refresh-token promise so concurrent callers wait on the same request
  refreshTokenPromise: Promise<any> | null = null;
  comingFromWhichDocumentType: any
  comingFromRegistrationSuccess = false;
  landingMenu: any = [
    {
      title: 'text_make_payment',
      external: true,
      url: environment.paymentUrl + this.platform,
      icon: 'cash',
      sub: null,
    },
    {
      title: 'text_reset_password',
      external: false,
      url: 'reset-password',
      icon: 'lock-closed',
      sub: null,
    },
    {
      title: 'text_go_to_desktop_site',
      external: true,
      url: 'https://services.georgia.gov/dhr/cspp/do/public/ApplyNow',
      icon: 'desktop',
      sub: null,
    },
    {
      title: 'text_app_status',
      external: false,
      url: 'application-status',
      icon: 'layer-group',
      sub: null,
    },
    {
      title: 'text_download_update',
      lines: 'none',
      external: false,
      url: 'app-download',
      icon: 'arrow-down-circle',
      sub: null,
    },
  ];

  options: any = [
    {
      name: 'menuItems.text_support_order',
      icon: 'rectangle-list-solid',
      url: 'support-order',
      lines: 'none',
    },
  ];

  payments: any = [
    {
      name: 'menuItems.text_make_payment',
      icon: 'money-solid',
      external: true,
      url: environment.paymentUrl + this.platform, 
      lines: 'inset',  
    },
    {
      name: 'menuItems.text_payment_history',
      icon: 'clock-full',
      external: false,
      url: 'payment-history',
      lines: 'none',
    },
  ];
  caseInfo: any = [
    {
      name: 'menuItems.text_case_activity',
      icon: 'list-check-solid',
      external: false,
      url: 'case-activity',
    },
    {
      name: 'menuItems.text_close_case',
      icon: 'close',
      external: false,
      url: 'close-my-case',
      lines: 'none',
    },
  ];
  appointments: any = [
    {
      name: 'menuItems.text_scheduled_appointments',
      icon: 'calendar',
      external: false,
      url: 'schedule-appointments',
    },
    {
      name: 'menuItems.text_make_an_appointment',
      icon: 'calendar',
      external: false,
      url: 'request-appointment',
      lines: 'none',
    },
  ];
  documents: any = [
    {
      name: 'menuItems.text_document_upload',
      icon: 'upload-solid',
      external: false,
      url: 'document-upload',
    },
    {
      name: 'menuItems.text_document_upload_history',
      icon: 'folder',
      external: false,
      url: 'docupload-history',
      lines: 'none',
    },
  ];
  licenses: any = [
    {
      name: 'menuItems.text_license_release',
      icon: 'license-release-solid',
      external: false,
      url: 'drivers-license',
    },
    {
      name: 'menuItems.txt_license_status',
      icon: 'license-status-solid',
      external: false,
      url: 'license-status',
      lines: 'none',
    },
  ];

  helpfulMenu: any = [

    {
      name: 'menuItems.text_technical_support',
      icon: 'technical-solid',
      external: false,
      url: 'technical-support',
    },

    {
      name: 'menuItems.text_helpful_information',
      icon: 'helpful-solid',
      external: false,
      url: 'helpful-information',
    },
    {
      name: 'menuItems.text_faq',
      icon: 'faq-solid',
      external: false,
      url: 'faqs',
    },
    {
      name: 'menuItems.text_customer_Service',
      icon: 'mail',
      external: false,
      url: 'customer-service',
    },
    {
      name: 'menuItems.text_user_agreement',
      icon: 'hand-shake',
      external: false,
      lines: 'none',
      url: 'user-agreement',
    },
  ];
  helpLinkItems: any = [
    {
      name: 'Drivers License Release Process',
      content: '**NOTE: html and link content in place within helplink.html***',
      url: 'https://online.dds.ga.gov/onlineservices/',
      index: 0,
    },
    {
      name: 'Fatherhood',
      content: `Through the Fatherhood Program, DCSS works with parents 
      who are unemployed or underemployed to help them to pay their full child
      support obligation. The program assists parents with locating resources leading
      to careers or employment paying above minimum wage, increased self-sufficiency,
      and financial involvement in the lives of their children.`,
      url: 'https://dcss.dhs.georgia.gov/fatherhood-program',
      index: 1,
    },
    {
      name: 'Parental Accountability Court',
      content: `The program works with Superior Court Judges to help non-custodial 
      parents overcome barriers to supporting their children through intense
      monitoring, judicial oversight, and partnerships with public and private
      agencies while focusing on personal responsibility and utilizing rehabilitation services.`,
      url: 'https://dcss.dhs.georgia.gov/problem-solving-courtparental-accountability-courts',
      index: 2,
    },
    {
      name: 'Access and Visitation',
      content: `Program (limited areas of GA) that can help parents establish 
      visitation with children, parenting classes, mediation and child access counseling.`,
      url: 'https://dcss.dhs.georgia.gov/child-access-visitation',
      index: 3,
    },
  ];

  informationItems: any = [
    {
      name: 'Office Finder',
      url: 'app.officefinder',
    },
  ];
  countries: any = [
    {
      code: 'USA',
      value: 'UNITED STATES',
    },
    {
      code: 'AFG',
      value: 'AFGHANISTAN',
    },
    {
      code: 'ALB',
      value: 'ALBANIA',
    },
    {
      code: 'DZA',
      value: 'ALGEIRA',
    },
    {
      code: 'ASM',
      value: 'AMERICAN SAMOA',
    },
    {
      code: 'AND',
      value: 'ANDORRA',
    },
    {
      code: 'AGO',
      value: 'ANGOLA',
    },
    {
      code: 'AIA',
      value: 'ANGUILLA',
    },
    {
      code: 'ATA',
      value: 'ANTARCTICA',
    },
    {
      code: 'ATG',
      value: 'ANTIGUA AND BARBUDA',
    },
    {
      code: 'ARG',
      value: 'ARGENTINA',
    },
    {
      code: 'ARM',
      value: 'ARMENIA',
    },
    {
      code: 'ABW',
      value: 'ARUBA',
    },
    {
      code: 'AUS',
      value: 'AUSTRALIA',
    },
    {
      code: 'AUT',
      value: 'AUSTRIA',
    },
    {
      code: 'AZE',
      value: 'AZERBAIJAN',
    },
    {
      code: 'BHS',
      value: 'BAHAMAS',
    },
    {
      code: 'BHR',
      value: 'BAHRAIN',
    },
    {
      code: 'BGD',
      value: 'BANGLADESH',
    },
    {
      code: 'BRB',
      value: 'BARBADOS',
    },
    {
      code: 'BLR',
      value: 'BELARUS',
    },
    {
      code: 'BEL',
      value: 'BELGIUM',
    },
    {
      code: 'BLZ',
      value: 'BELIZE',
    },
    {
      code: 'BEN',
      value: 'BENIN',
    },
    {
      code: 'BMU',
      value: 'BERMUDA',
    },
    {
      code: 'BTN',
      value: 'BHUTAN',
    },
    {
      code: 'BOL',
      value: 'BOLIVIA',
    },
    {
      code: 'BIH',
      value: 'BOSNIA AND HERZEGOVINA',
    },
    {
      code: 'BWA',
      value: 'BOTSWANA',
    },
    {
      code: 'BVT',
      value: 'BOUVET ISLAND',
    },
    {
      code: 'BRA',
      value: 'BRAZIL',
    },
    {
      code: 'IOT',
      value: 'BRITISH INDIAN OCEAN TERRITORY',
    },
    {
      code: 'BRN',
      value: 'BRUNEI DARUSSALAM',
    },
    {
      code: 'BGR',
      value: 'BULGARIA',
    },
    {
      code: 'BFA',
      value: 'BURKINA FASO',
    },
    {
      code: 'BDI',
      value: 'BURUNDI',
    },
    {
      code: 'KHM',
      value: 'CAMBODIA',
    },
    {
      code: 'CMR',
      value: 'CAMEROON',
    },
    {
      code: 'CAN',
      value: 'CANADA',
    },
    {
      code: 'CPV',
      value: 'CAPE VERDE',
    },
    {
      code: 'CYM',
      value: 'CAYMAN ISLANDS',
    },
    {
      code: 'CAF',
      value: 'CENTRAL AFRICAN REPUBLIC',
    },
    {
      code: 'TCD',
      value: 'CHAD',
    },
    {
      code: 'CHL',
      value: 'CHILE',
    },
    {
      code: 'CHN',
      value: 'CHINA',
    },
    {
      code: 'CXR',
      value: 'CHRISTMAS ISLAND',
    },
    {
      code: 'CCK',
      value: 'COCOS (KEELING) ISLANDS',
    },
    {
      code: 'COL',
      value: 'COLOMBIA',
    },
    {
      code: 'COM',
      value: 'COMOROS',
    },
    {
      code: 'COG',
      value: 'CONGO',
    },
    {
      code: 'COK',
      value: 'COOK ISLANDS',
    },
    {
      code: 'CRI',
      value: 'COSTA RICA',
    },
    {
      code: 'CIV',
      value: "COTE D'IVOIRE",
    },
    {
      code: 'HRV',
      value: 'CROTIA (LOCAL NAME: HRVATSKA)',
    },
    {
      code: 'CUB',
      value: 'CUBA',
    },
    {
      code: 'CYP',
      value: 'CYPRUS',
    },
    {
      code: 'CZE',
      value: 'CZECH REPUBLIC',
    },
    {
      code: 'DNK',
      value: 'DENMARK',
    },
    {
      code: 'DJI',
      value: 'DJIBOUTI',
    },
    {
      code: 'DMA',
      value: 'DOMINICA',
    },
    {
      code: 'DOM',
      value: 'DOMINICAN REPUBLIC',
    },
    {
      code: 'TLS',
      value: 'EAST TIMOR',
    },
    {
      code: 'ECU',
      value: 'ECUADOR',
    },
    {
      code: 'EGY',
      value: 'EGYPT',
    },
    {
      code: 'SLV',
      value: 'EL SALVADOR',
    },
    {
      code: 'GNQ',
      value: 'EQUATORIAL GUINEA',
    },
    {
      code: 'ERI',
      value: 'ERITREA',
    },
    {
      code: 'EST',
      value: 'ESTONIA',
    },
    {
      code: 'ETH',
      value: 'ETHIOPIA',
    },
    {
      code: 'FLK',
      value: 'FALKLAND ISLANDS (MALVINAS)',
    },
    {
      code: 'FRO',
      value: 'FAROE ISLANDS',
    },
    {
      code: 'FJI',
      value: 'FIJI',
    },
    {
      code: 'FIN',
      value: 'FINLAND',
    },
    {
      code: 'FRA',
      value: 'FRANCE',
    },
    {
      code: 'FXX',
      value: 'FRANCE, METROPOLITAN',
    },
    {
      code: 'GUF',
      value: 'FRENCH GUIANA',
    },
    {
      code: 'PYF',
      value: 'FRENCH POLYNESIA',
    },
    {
      code: 'ATF',
      value: 'FRENCH SOUTHERN TERRITORIES',
    },
    {
      code: 'GAB',
      value: 'GABON',
    },
    {
      code: 'GMB',
      value: 'GAMBIA',
    },
    {
      code: 'GEO',
      value: 'GEORGIA',
    },
    {
      code: 'DEU',
      value: 'GERMANY',
    },
    {
      code: 'GHA',
      value: 'GHANA',
    },
    {
      code: 'GIB',
      value: 'GIBRALTAR',
    },
    {
      code: 'GRC',
      value: 'GREECE',
    },
    {
      code: 'GRL',
      value: 'GREENLAND',
    },
    {
      code: 'GRD',
      value: 'GRENADA',
    },
    {
      code: 'GLP',
      value: 'GUADELOUPE',
    },
    {
      code: 'GUM',
      value: 'GUAM',
    },
    {
      code: 'GTM',
      value: 'GUATEMALA',
    },
    {
      code: 'GIN',
      value: 'GUINEA',
    },
    {
      code: 'GNB',
      value: 'GUINEA-BISSAU',
    },
    {
      code: 'GUY',
      value: 'GUYANA',
    },
    {
      code: 'HTI',
      value: 'HAITI',
    },
    {
      code: 'HMD',
      value: 'HEARD ISLAND AND MCDONALD ISLANDS',
    },
    {
      code: 'HND',
      value: 'HONDURAS',
    },
    {
      code: 'HKG',
      value: 'HONG KONG',
    },
    {
      code: 'HUN',
      value: 'HUNGARY',
    },
    {
      code: 'ISL',
      value: 'ICELAND',
    },
    {
      code: 'IND',
      value: 'INDIA',
    },
    {
      code: 'IDN',
      value: 'INDONESIA',
    },
    {
      code: 'IRN',
      value: 'IRAN, ISLAMIC REPUBLIC OF',
    },
    {
      code: 'IRQ',
      value: 'IRAQ',
    },
    {
      code: 'IRL',
      value: 'IRELAND',
    },
    {
      code: 'ISR',
      value: 'ISRAEL',
    },
    {
      code: 'ITA',
      value: 'ITALY',
    },
    {
      code: 'JAM',
      value: 'JAMAICA',
    },
    {
      code: 'JPN',
      value: 'JAPAN',
    },
    {
      code: 'JOR',
      value: 'JORDAN',
    },
    {
      code: 'KAZ',
      value: 'KAZAKHSTAN',
    },
    {
      code: 'KEN',
      value: 'KENYA',
    },
    {
      code: 'KIR',
      value: 'KIRIBATI',
    },
    {
      code: 'PRK',
      value: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC",
    },
    {
      code: 'KOR',
      value: 'KOREA, REPUBLIC OF',
    },
    {
      code: 'KWT',
      value: 'KUWAIT',
    },
    {
      code: 'KGZ',
      value: 'KYRGYZSTAN',
    },
    {
      code: 'LAO',
      value: "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
    },
    {
      code: 'LVA',
      value: 'LATVIA',
    },
    {
      code: 'LBN',
      value: 'LEBANON',
    },
    {
      code: 'LSO',
      value: 'LESOTHO',
    },
    {
      code: 'LBR',
      value: 'LIBERIA',
    },
    {
      code: 'LBY',
      value: 'LIBYAN ARAB JAMAHIRIYA',
    },
    {
      code: 'LIE',
      value: 'LIECHTENSTEIN',
    },
    {
      code: 'LTU',
      value: 'LITHUANIA',
    },
    {
      code: 'LUX',
      value: 'LUXEMBOURG',
    },
    {
      code: 'MAC',
      value: 'MACAU',
    },
    {
      code: 'MKD',
      value: 'MACEDONIA, THE FORMER YUGOSLAV REPU',
    },
    {
      code: 'MDG',
      value: 'MADAGASCAR',
    },
    {
      code: 'MWI',
      value: 'MALAWI',
    },
    {
      code: 'MYS',
      value: 'MALAYSIA',
    },
    {
      code: 'MDV',
      value: 'MALDIVES',
    },
    {
      code: 'MLI',
      value: 'MALI',
    },
    {
      code: 'MLT',
      value: 'MALTA',
    },
    {
      code: 'MHL',
      value: 'MARSHALL ISLANDS',
    },
    {
      code: 'MTQ',
      value: 'MARTINIQUE',
    },
    {
      code: 'MRT',
      value: 'MAURITANIA',
    },
    {
      code: 'MUS',
      value: 'MAURITIUS',
    },
    {
      code: 'MYT',
      value: 'MAYOTTE',
    },
    {
      code: 'MEX',
      value: 'MEXICO',
    },
    {
      code: 'FSM',
      value: 'MICRONESIA, FEDERATED STATES OF',
    },
    {
      code: 'MDA',
      value: 'MOLDOVA, REPUBLIC OF',
    },
    {
      code: 'MCO',
      value: 'MONACO',
    },
    {
      code: 'MNG',
      value: 'MONGOLIA',
    },
    {
      code: 'MSR',
      value: 'MONTSERRAT',
    },
    {
      code: 'MAR',
      value: 'MOROCCO',
    },
    {
      code: 'MOZ',
      value: 'MOZAMBIQUE',
    },
    {
      code: 'MMR',
      value: 'MYANMAR',
    },
    {
      code: 'NAM',
      value: 'NAMIBIA',
    },
    {
      code: 'NRU',
      value: 'NAURU',
    },
    {
      code: 'NPL',
      value: 'NEPAL',
    },
    {
      code: 'NLD',
      value: 'NETHERLANDS',
    },
    {
      code: 'ANT',
      value: 'NETHERLANDS ANTILLES',
    },
    {
      code: 'NCL',
      value: 'NEW CALEDONIA',
    },
    {
      code: 'NZL',
      value: 'NEW ZEALAND',
    },
    {
      code: 'NIC',
      value: 'NICARAGUA',
    },
    {
      code: 'NER',
      value: 'NIGER',
    },
    {
      code: 'NGA',
      value: 'NIGERIA',
    },
    {
      code: 'NIU',
      value: 'NIUE',
    },
    {
      code: 'NFK',
      value: 'NORFOLK ISLAND',
    },
    {
      code: 'MNP',
      value: 'NORTHERN MARIANA ISLANDS',
    },
    {
      code: 'NOR',
      value: 'NORWAY',
    },
    {
      code: 'OMN',
      value: 'OMAN',
    },
    {
      code: 'PAK',
      value: 'PAKISTAN',
    },
    {
      code: 'PLW',
      value: 'PALAU',
    },
    {
      code: 'PAN',
      value: 'PANAMA',
    },
    {
      code: 'PNG',
      value: 'PAPUA NEW GUINEA',
    },
    {
      code: 'PRY',
      value: 'PARAGUAY',
    },
    {
      code: 'PER',
      value: 'PERU',
    },
    {
      code: 'PHL',
      value: 'PHILIPPINES',
    },
    {
      code: 'PCN',
      value: 'PITCAIRN',
    },
    {
      code: 'POL',
      value: 'POLAND',
    },
    {
      code: 'PRT',
      value: 'PORTUGAL',
    },
    {
      code: 'PRI',
      value: 'PUERTO RICO',
    },
    {
      code: 'QAT',
      value: 'QATAR',
    },
    {
      code: 'REU',
      value: 'REUNION',
    },
    {
      code: 'ROU',
      value: 'ROMANIA',
    },
    {
      code: 'RUS',
      value: 'RUSSIAN FEDERATION',
    },
    {
      code: 'RWA',
      value: 'RWANDA',
    },
    {
      code: 'SHN',
      value: 'SAINT HELENA',
    },
    {
      code: 'KNA',
      value: 'SAINT KITTS AND NEVIS',
    },
    {
      code: 'LCA',
      value: 'SAINT LUCIA',
    },
    {
      code: 'SPM',
      value: 'SAINT PIERRE AND MIQUELON',
    },
    {
      code: 'VCT',
      value: 'SAINT VINCENT AND THE GRENADINES',
    },
    {
      code: 'WSM',
      value: 'SAMOA',
    },
    {
      code: 'SMR',
      value: 'SAN MARINO',
    },
    {
      code: 'STP',
      value: 'SAO TOME AND PRINCIPE',
    },
    {
      code: 'SAU',
      value: 'SAUDI ARABIA',
    },
    {
      code: 'SEN',
      value: 'SENEGAL',
    },
    {
      code: 'SYC',
      value: 'SEYCHELLES',
    },
    {
      code: 'SLE',
      value: 'SIERRA LEONE',
    },
    {
      code: 'SGP',
      value: 'SINGAPORE',
    },
    {
      code: 'SVK',
      value: 'SLOVAKIA (SLOVAK REPUBLIC)',
    },
    {
      code: 'SVN',
      value: 'SLOVENIA',
    },
    {
      code: 'SLB',
      value: 'SOLOMON ISLANDS',
    },
    {
      code: 'SOM',
      value: 'SOMALIA',
    },
    {
      code: 'ZAF',
      value: 'SOUTH AFRICA',
    },
    {
      code: 'ESP',
      value: 'SPAIN',
    },
    {
      code: 'LKA',
      value: 'SRI LANKA',
    },
    {
      code: 'SDN',
      value: 'SUDAN',
    },
    {
      code: 'SUR',
      value: 'SURINAME',
    },
    {
      code: 'SJM',
      value: 'SVALBARD AND JAN MAYEN ISLANDS',
    },
    {
      code: 'SWZ',
      value: 'SWAZILAND',
    },
    {
      code: 'SWE',
      value: 'SWEDEN',
    },
    {
      code: 'CHE',
      value: 'SWITZERLAND',
    },
    {
      code: 'SYR',
      value: 'SYRIAN ARAB REPUBLIC',
    },
    {
      code: 'TWN',
      value: 'TAIWAN, PROVINCE OF CHINA',
    },
    {
      code: 'TJK',
      value: 'TAJIKISTAN',
    },
    {
      code: 'TZA',
      value: 'TANZANIA, UNITED REPUBLIC OF',
    },
    {
      code: 'THA',
      value: 'THAILAND',
    },
    {
      code: 'TGO',
      value: 'TOGO',
    },
    {
      code: 'TKL',
      value: 'TOKELAU',
    },
    {
      code: 'TON',
      value: 'TONGA',
    },
    {
      code: 'TTO',
      value: 'TRINIDAD AND TOBAGO',
    },
    {
      code: 'TUN',
      value: 'TUNISIA',
    },
    {
      code: 'TUR',
      value: 'TURKEY',
    },
    {
      code: 'TKM',
      value: 'TURKMENISTAN',
    },
    {
      code: 'TCA',
      value: 'TURKS AND CAICOS ISLANDS',
    },
    {
      code: 'TUV',
      value: 'TUVALU',
    },
    {
      code: 'UGA',
      value: 'UGANDA',
    },
    {
      code: 'UKR',
      value: 'UKRAINE',
    },
    {
      code: 'ARE',
      value: 'UNITED ARAB EMIRATES',
    },
    {
      code: 'GBR',
      value: 'UNITED KINGDOM'
    },
    {
      code: 'UMI',
      value: 'UNITED STATES MINOR OUTLYING ISLAND',
    },
    {
      code: 'URY',
      value: 'URUGUAY',
    },
    {
      code: 'UZB',
      value: 'UZBEKISTAN',
    },
    {
      code: 'VUT',
      value: 'VANUATU',
    },
    {
      code: 'VAT',
      value: 'VATICAN CITY STATE (HOLY SEE)',
    },
    {
      code: 'VEN',
      value: 'VENEZUELA',
    },
    {
      code: 'VNM',
      value: 'VIET NAM',
    },
    {
      code: 'VGB',
      value: 'VIRGIN ISLANDS (BRITISH)',
    },
    {
      code: 'VIR',
      value: 'VIRGIN ISLANDS (U.S.)',
    },
    {
      code: 'WLF',
      value: 'WALLIS AND FUTUNA ISLANDS',
    },
    {
      code: 'ESH',
      value: 'WESTERN SAHARA',
    },
    {
      code: 'YEM',
      value: 'YEMEN',
    },
    {
      code: 'YUG',
      value: 'YUGOSLAVIA',
    },
    {
      code: 'ZAR',
      value: 'ZAIRE',
    },
    {
      code: 'ZMB',
      value: 'ZAMBIA',
    },
    {
      code: 'ZWE',
      value: 'ZIMBABWE',
    },
  ];

  states: any = [
    {
      code: 'AL',
      value: 'ALABAMA',
    },
    {
      code: 'AK',
      value: 'ALASKA',
    },
    {
      code: 'AS',
      value: 'AMERICAN SOMOA',
    },
    {
      code: 'AZ',
      value: 'ARIZONA',
    },
    {
      code: 'AR',
      value: 'ARKANSAS',
    },
    {
      code: 'AA',
      value: 'ARMED FORCES AMERICAS',
    },
    {
      code: 'AE',
      value: 'ARMED FORCES EUROPE, MIDEAST',
    },
    {
      code: 'AP',
      value: 'ARMED FORCES PACIFIC',
    },
    {
      code: 'CA',
      value: 'CALIFORNIA',
    },
    {
      code: 'CO',
      value: 'COLORADO',
    },
    {
      code: 'CT',
      value: 'CONNECTICUT',
    },
    {
      code: 'DE',
      value: 'DELAWARE',
    },
    {
      code: 'DC',
      value: 'DISTRICT OF COLUMBIA',
    },
    {
      code: 'FL',
      value: 'FLORIDA',
    },
    {
      code: 'GA',
      value: 'GEORGIA',
    },
    {
      code: 'GU',
      value: 'GUAM',
    },
    {
      code: 'HI',
      value: 'HAWAII',
    },
    {
      code: 'ID',
      value: 'IDAHO',
    },
    {
      code: 'IL',
      value: 'ILLINOIS',
    },
    {
      code: 'IN',
      value: 'INDIANA',
    },
    {
      code: 'IA',
      value: 'IOWA',
    },
    {
      code: 'KS',
      value: 'KANSAS',
    },
    {
      code: 'KY',
      value: 'KENTUCKY',
    },
    {
      code: 'LA',
      value: 'LOUISIANA',
    },
    {
      code: 'ME',
      value: 'MAINE',
    },
    {
      code: 'MP',
      value: 'MARIANA PROVINCE',
    },
    {
      code: 'MD',
      value: 'MARYLAND',
    },
    {
      code: 'MA',
      value: 'MASSACHUSETTS',
    },
    {
      code: 'MI',
      value: 'MICHIGAN',
    },
    {
      code: 'MN',
      value: 'MINNESOTA',
    },
    {
      code: 'MS',
      value: 'MISSISSIPPI',
    },
    {
      code: 'MO',
      value: 'MISSOURI',
    },
    {
      code: 'MT',
      value: 'MONTANA',
    },
    {
      code: 'NE',
      value: 'NEBRASKA',
    },
    {
      code: 'NV',
      value: 'NEVADA',
    },
    {
      code: 'NH',
      value: 'NEW HAMPSHIRE',
    },
    {
      code: 'NJ',
      value: 'NEW JERSEY',
    },
    {
      code: 'NM',
      value: 'NEW MEXICO',
    },
    {
      code: 'NY',
      value: 'NEW YORK',
    },
    {
      code: 'NC',
      value: 'NORTH CAROLINA',
    },
    {
      code: 'ND',
      value: 'NORTH DAKOTA',
    },
    {
      code: 'OH',
      value: 'OHIO',
    },
    {
      code: 'OK',
      value: 'OKLAHOMA',
    },
    {
      code: 'OR',
      value: 'OREGON',
    },
    {
      code: 'XX',
      value: 'OUT OF COUNTRY',
    },
    {
      code: 'PA',
      value: 'PENNSYLVANIA',
    },
    {
      code: 'PR',
      value: 'PUERTO RICO',
    },
    {
      code: 'RI',
      value: 'RHODE ISLAND',
    },
    {
      code: 'SC',
      value: 'SOUTH CAROLINA',
    },
    {
      code: 'SD',
      value: 'SOUTH DAKOTA',
    },
    {
      code: 'TN',
      value: 'TENNESSEE',
    },
    {
      code: 'TX',
      value: 'TEXAS',
    },
    {
      code: 'UT',
      value: 'UTAH',
    },
    {
      code: 'VT',
      value: 'VERMONT',
    },
    {
      code: 'VI',
      value: 'VIRGIN ISLANDS',
    },
    {
      code: 'VA',
      value: 'VIRGINIA',
    },
    {
      code: 'WA',
      value: 'WASHINGTON',
    },
    {
      code: 'WV',
      value: 'WEST VIRGINIA',
    },
    {
      code: 'WI',
      value: 'WISCONSIN',
    },
    {
      code: 'WY',
      value: 'WYOMING',
    },
  ];
  constructor(
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private alertCtrl: AlertController
  ) {
    if (
      Capacitor.getPlatform() === 'android' &&
      Capacitor.isPluginAvailable('App')
    ) {
      this.platform = '?platform=android';
    }
    if (
      Capacitor.getPlatform() === 'ios' &&
      Capacitor.isPluginAvailable('App')
    ) {
      this.platform = '?platform=ios';
    } else {
      this.platform = '?platform=dcssmobile';
    }
    this.presentLoading();
  }

  changeLanguage() {
    if (this.language === 'es') {
      this.language = 'en';
    } else {
      this.language = 'es';
    }
    this.translate.use(this.language);
  }

  async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      cssClass: 'my-custom-loading-class',
      message: 'Please wait...',
    });
  }

  async showAlertMessage(messageText: any) {
    const alert = await this.alertCtrl.create({
      header: 'Alert',
      message: messageText,
      buttons: [
        {
          text: 'Okay',
          id: 'confirm-button',
          handler: () => {},
        },
      ],
    });
    alert.present();
  }
}
